import {
  Divider,
  Flex,
  Switch,
  Text,
  Tooltip,
  type MantineColor,
  StyleProp,
  MantineSize,
} from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { IconHelp } from '@tabler/icons-react';
import React from 'react';

type SettingsRowProps = {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  showDivider?: boolean;
  tooltip?: string;
  titleColor?: StyleProp<MantineColor>;
  titleSize?: MantineSize | (string & {});
  right?: React.ReactNode;
};

export function SettingsRow({
  title,
  description,
  checked,
  onChange,
  showDivider,
  tooltip,
  right,
  titleColor = 'gray.10',
  titleSize = 'textMd',
}: SettingsRowProps) {
  return (
    <Flex direction="column" gap="xs" role={'group'}>
      <Flex justify="space-between">
        <Flex align={'center'} gap={'xxs'}>
          <Flex direction="column" gap="xxxs" flex={1}>
            <Text size={titleSize} fw={FONT_WEIGHTS.medium} c={titleColor}>
              {title}
            </Text>
            {description && (
              <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.6">
                {description}
              </Text>
            )}
          </Flex>
          {tooltip && (
            <Tooltip label={tooltip}>
              <IconHelp stroke={2} size={20} />
            </Tooltip>
          )}
        </Flex>

        <Flex direction={'row'} gap={'sm'} align={'center'}>
          {right && right}
          <Switch checked={checked} onChange={event => onChange(event.currentTarget.checked)} />
        </Flex>
      </Flex>
      {showDivider && <Divider />}
    </Flex>
  );
}
